module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Ordering","next":"Next","pressEnter":"Press <b>ENTER</b>","linebreak":"<b>SHIFT + ENTER</b> to make a line break"},"ar":{"title":"طلب الخدمة","next":"التالي","pressEnter":"اضغط <b>ENTER</b>","linebreak":"<b>SHIFT + ENTER</b> لاضافة سطر"}}')
  delete Component.options._Ctor
}
